import * as z from 'zod';
import { KeepTypeAlias } from '../utilities';

export const applicationContextSchema = z.record(z.string(), z.unknown());

export type ApplicationContext = KeepTypeAlias<z.infer<typeof applicationContextSchema>>;
